import { colors } from '../styles'

export const button = {
  baseStyle: {
    borderRadius: '50px',
    boxShadow: '0px 2px 26px rgba(82, 215, 0, 0.1)',
    width: '100%',
  },
  sizes: {},
  variants: {
    secondary: {
      backgroundColor: colors.secondary.base,
      border: `1px solid ${colors.secondary.base}`,
      color: '#FFFFFF',
    },
    primary: {
      backgroundColor: colors.primary.base,
      border: `1px solid ${colors.primary.base}`,
      color: '#FFFFFF',
    },
    primaryLight: {
      backgroundColor: colors.primary.lighter,
      border: `1px solid ${colors.primary.base}`,
      color: '#FFFFFF',
      borderRadius: '8px',
    },
    gray: {
      backgroundColor: colors.gray[100],
    },
    gray500: {
      backgroundColor: colors.gray[500],
      color: '#FFFFFF',
    },
    gray800: {
      backgroundColor: colors.gray[800],
      color: '#FFFFFF',
    },
    white: {
      border: `1px solid ${colors.secondary.other}`,
      boxSizing: 'border-box',
      boxShadow: '0px 7px 25px rgba(0, 0, 0, 0.15)',
      borderRadius: '15px',
      backgroundColor: '#FFFFFF',
    },
    black: {
      backgroundColor: 'black',
      borderRadius: '16px',
      color: colors.gray.soft,
    },
    grayNoRadius: {
      backgroundColor: colors.gray[100],
      borderRadius: '5px',
      color: '#FFFFFF',
    },
    blackNoRadius: {
      backgroundColor: colors.gray[900],
      borderRadius: '5px',
      color: colors.gray.soft,
    },
    searchbar: {
      background: 'none',
      color: colors.text.default,
      borderRadius: '4px',
      boxShadow: 'none',
    },
    fullWidth: {
      width: '100vw',
      position: 'fixed',
      top: '90px',
      left: 0,
      zIndex: 10,
      height: '88px',
      backgroundColor: colors.gray[50],
      borderRadius: 0,
    },
    error: {
      backgroundColor: colors.log.error,
      color: '#FFFFFF',
    },
  },
  defaultProps: {
    variant: 'primary',
  },
}
